<button
  type="button"
  [id]="buttonId()"
  data-dgat="skip-nav-da2"
  [class]="buttonClasses"
  (click)="moveFocus($event)"
  (keydown.enter)="moveFocus($event)"
  (keyup.space)="moveFocus($event)"
>
  {{ linkText() }}
</button>
